// @ts-nocheck

import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';

const EmailProviderBlueprint = new ReduxAsyncAction('EMAIL_PROVIDER_BLUEPRINT');
// biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
EmailProviderBlueprint.registerRequest(function (domain) {
  return dash_api.get('/v1/email-blueprint').then(({ data }) => data);
});

export const getEmailProviderBlueprint = EmailProviderBlueprint.request;
export const EMAIL_PROVIDER_BLUEPRINT = EmailProviderBlueprint.constants;
